import { render } from "./TableViewEditorCmp.vue?vue&type=template&id=afcf1614"
import script from "./TableViewEditorCmp.vue?vue&type=script&lang=js"
export * from "./TableViewEditorCmp.vue?vue&type=script&lang=js"

import "./TableViewEditorCmp.vue?vue&type=style&index=0&id=afcf1614&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__